import { Box } from '@mantine/core';
import { useState } from 'react';
import CallTextArea from '../Gong-call/CallTextArea';
import { SlackConversationModal } from '../../../../../evidences/SlackConversationModal';
import { getOriginalItemViewLabel } from '../../../../../../utils/evidence/businessCategoryOriginalLabels';
import { getEvidenceDisplayTitle } from '../../../../../../utils';

const SlackConversation = ({ item }: { item: any }) => {
  const [opened, setOpened] = useState(false);

  const text = item?.text;
  // A blank title falls back to the first few words of the description — the text area
  // below still shows the full, untruncated text unchanged.
  const title = getEvidenceDisplayTitle(item?.title, text) || undefined;
  const mlData = item?.ml;
  const excerptsArr = item?.excerpts || [];
  const chatLinkLabel =
    getOriginalItemViewLabel(item?.cxItem?.businessCategory) ||
    getOriginalItemViewLabel('chat');

  return (
    <>
      <SlackConversationModal
        item={{
          cxItemId: item?.cxItemId,
          cxOriginId: item?.cxOriginId,
          cxItem: item?.cxItem,
          excerpts: excerptsArr,
        }}
        opened={opened}
        onClose={() => setOpened(false)}
      />
      <Box mt={15}>
        <CallTextArea
          title={title}
          text={text}
          mlData={mlData}
          excerptsArr={excerptsArr}
          setOpened={setOpened}
          type="conversation"
          originalItemLinkLabel={chatLinkLabel}
        />
      </Box>
    </>
  );
};

export default SlackConversation;
